import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';

export const Spinner = styled.div`
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
  min-height: ${({ minHeight }) => (minHeight ? `${minHeight}px` : 'initial')};
`;

export const BarContainer = styled.div`
  position: relative;
`;

const spinnerFrames = keyframes`
  0% { height: 25%; }
  50% { height: 40%; }
  100% { height: 100%; }
`;

const SpinnerBar = styled.span`
  border-radius: 2px;
  background: hsl(0, 0%, 83%);
  display: block;
  width: 30%;
  position: absolute;
  height: 0;
  animation: ${spinnerFrames} 0.35s linear infinite alternate;
`;

export const FirstBar = styled(SpinnerBar)`
  top: 0;
  left: 0;
`;

export const SecondBar = styled(SpinnerBar)`
  top: 0;
  left: 35%;
  animation-delay: 0.1s;
`;

export const ThirdBar = styled(SpinnerBar)`
  top: 0;
  left: 70%;
  animation-delay: 0.2s;
`;
